import { APIService } from 'connectors/api/rest';

export const Stores = {
  async getList(params) {
    try {
      return await APIService.GET('stores', params);
    } catch (e) {
      return null;
    }
  },
};
